// extracted by mini-css-extract-plugin
module.exports = {"tooltipPopup":"styles_tooltipPopup__2yNZd"};